var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "view",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12701",
    "data-name": "Path 12701",
    d: "M25.453,14.284C23.53,10.327,18.83,7.659,13.5,7.5c-5.33.159-10.029,2.827-11.952,6.784a.515.515,0,0,0,0,.433C3.472,18.673,8.171,21.341,13.5,21.5c5.33-.159,10.029-2.827,11.952-6.784a.515.515,0,0,0,0-.433ZM13.5,20.227c-4.24,0-8.72-2.5-10.344-5.727C4.78,11.274,9.261,8.773,13.5,8.773s8.72,2.5,10.344,5.727C22.221,17.726,17.741,20.227,13.5,20.227Z",
    transform: "translate(-1.501 -7.5)",
    fill: "#600097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12702",
    "data-name": "Path 12702",
    d: "M18.6,15A3.816,3.816,0,0,0,15,19a3.816,3.816,0,0,0,3.6,4,3.816,3.816,0,0,0,3.6-4A3.816,3.816,0,0,0,18.6,15Zm0,6.667A2.544,2.544,0,0,1,16.2,19a2.544,2.544,0,0,1,2.4-2.667A2.544,2.544,0,0,1,21,19,2.544,2.544,0,0,1,18.6,21.667Z",
    transform: "translate(-6.6 -12)",
    fill: "#600097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.90b21bf14336a739c084332204f2cddc.svg";
export { ForwardRef as ReactComponent };